import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/deflayout.vue'

Vue.use(VueRouter)
const staticRoutes = [
  {
    path: '/',
    name: 'index',
    redirect: '/index',
    component: layout,
    meta: { title: '欢迎页', icon: 'mdi-home' },
    children: [
      {
        path: 'index',
        name: 'index',
        meta: { title: '首页', icon: 'mdi-home' },
        component: () => import('@/views/index.vue'),
      }
    ]
  }
]

const router = createRouter()

function createRouter() {
  return new VueRouter({
    mode: "history",
    routes: staticRoutes,
  })
}

/*重置路由*/
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
